<article class="card" [class.card--list]="viewMode() === 'list'" [class.card--out-of-stock]="isOutOfStock()" [class.card--wishlist]="variant() === 'wishlist'" [class.card--ea]="isEarlyAccess()" (click)="onCardClick()" [attr.aria-label]="product().name">
  <!-- Image container with foil overlay -->
  <div class="card__image-wrap" [attr.data-variant]="isSingle() ? product().variant : null" (click)="onImageClick($event)">
    <img class="card__image" [src]="product().imageUrl" [alt]="imageAlt()" loading="lazy" />

    @if (hasSecondImage()) {
    <img class="card__image card__image--secondary" [src]="product().imageUrl2!" [alt]="imageAlt()" loading="lazy" />
    }

    @if (viewMode() !== 'list') {
      <!-- Corazón de la lista de deseos (B29): esquina superior izquierda; la derecha es del comparador. -->
      <app-wishlist-button class="card__wishlist-btn" [productId]="product().id" [iconSize]="14" />

      <button
        type="button"
        class="card__compare-btn"
        [class.card__compare-btn--selected]="isInCompare()"
        [disabled]="!canAddToCompare()"
        [attr.aria-pressed]="isInCompare()"
        [attr.aria-label]="compareTooltip()"
        [attr.title]="compareTooltip()"
        (click)="onCompareToggle($event)"
      >
        @if (isInCompare()) {
          <app-icon [icon]="checkIcon" [size]="14" color="currentColor" />
        } @else {
          <app-icon [icon]="compareIcon" [size]="14" color="currentColor" />
        }
      </button>
    }

    <!-- Wishlist notify-active overlay -->
    @if (showWishlistOverlay()) {
      <div class="card__wishlist-overlay">
        <div class="card__wishlist-overlay-icon">
          <app-icon [icon]="checkIcon" [size]="20" color="white" />
        </div>
        <span class="card__wishlist-overlay-text">Te avisaremos</span>
      </div>
    }

    @if (viewMode() !== 'list') {
      @if (product().isPreSale && !isOutOfStock()) {
        <div class="card__quick-actions">
          <app-button variant="primary" size="sm" (click)="onReserve($event)">
            <div class="flex flex-row gap-x-2 items-center py-1">
              <app-icon [icon]="calendarIcon" [size]="14" />
              <span>Reservar</span>
            </div>
          </app-button>
        </div>
      } @else if (isPrepurchaseSoldOut()) {
        <div class="card__quick-actions">
          <app-button
            variant="primary"
            size="sm"
            class="btn-sold-out"
            [appTooltip]="prepurchaseSoldOutMessage"
            (click)="onPrepurchaseSoldOutClick($event)"
          >
            <div class="flex flex-row gap-x-2 items-center py-1">
              <app-icon [icon]="calendarIcon" [size]="14" />
              <span>Precompra Agotada</span>
            </div>
          </app-button>
        </div>
      } @else if (!isOutOfStock()) {
        <div class="card__quick-actions">
          <app-button variant="primary" size="sm" (click)="onAddToCart($event)">
            <div class="flex flex-row gap-x-2 items-center py-1">
              <app-icon [icon]="cartIcon" [size]="14" />
              <span>Agregar</span>
            </div>
          </app-button>
        </div>
      } @else if (!product().isPreSale) {
        <!-- Notify sólo aplica a productos regulares agotados, nunca a precompras -->
        <div class="card__quick-actions">
          @if (isNotifyActive()) {
            <app-button class="card__notify-cancel" variant="ghost" size="sm" (click)="onNotify($event)">
              <div class="card__notify-cancel-btn flex flex-row gap-x-2 items-center py-1">
                <app-icon [icon]="bellOffIcon" [size]="14" />
                <span>Ya no me avises</span>
              </div>
            </app-button>
          } @else {
            <app-button variant="secondary" size="sm" (click)="onNotify($event)">
              <div class="flex flex-row gap-x-2 items-center py-1">
                <app-icon [icon]="bellIcon" [size]="14" />
                <span>Avisarme</span>
              </div>
            </app-button>
          }
        </div>
      }
    }
  </div>

  <!-- Info section -->
  <div class="card__info">
    <!-- Product name -->
    <h3 class="card__name">{{ product().name }}</h3>

    <!-- Set + collector number + Variant badge -->
    <div class="card__meta">
      <span class="card__set">{{ product().setName }}@if (viewMode() === 'list' && product().collectorNumber) { <span class="card__collector-number">· {{ product().collectorNumber }}</span>}</span>
      @if (isSingle()) {
      <app-variant-badge [variant]="product().variant">
        {{ variantLabel() }}
      </app-variant-badge>
      }
    </div>
    <div class="card__badges">
      @if (product().isNew) {
      <app-badge variant="new">Novedad</app-badge>
      }
      @if (product().isOnSale && discountPercent() > 0 && !isOutOfStock()) {
      <app-badge variant="sale">-{{ discountPercent() }}%</app-badge>
      }
      @if (isOutOfStock()) {
      <app-badge variant="sold-out">Agotado</app-badge>
      }
      <!-- Slot PROPIO del badge VIP (R3): ya no desplaza a «Pre-venta»; una
           precompra restringida muestra los dos. -->
      @if (isEarlyAccess()) {
      <app-badge variant="vip">{{ eaBadgeText() }}</app-badge>
      }
      @if (product().isPreSale) {
      <app-badge variant="pre-sale">Pre-venta</app-badge>
      }
    </div>

    <!-- Requisito Perrón Points (solo lista de precompras, D5) -->
    @if (showEaRequirement() && isEarlyAccess()) {
    <p class="card__ea-requirement">
      <app-pp-coin [size]="14" />{{ eaRequirementText() }}
    </p>
    }

    <!-- Condition (singles only) -->
    @if (isSingle() && conditionTone(); as tone) {
    <div class="card__condition">
      <app-badge [variant]="tone">{{ conditionLabel() }}</app-badge>
    </div>
    }

    <!-- Price (shown in grid; hidden by CSS in list mode) -->
    @if (!isOutOfStock()) {
    <div class="card__price-block">
      @if (product().isOnSale && product().originalPrice != null) {
      <span class="card__original-price">{{ formattedOriginalPrice() }}</span>
      }
      <span class="card__price">{{ formattedPrice() }}</span>
    </div>
    }

    <!-- Low stock warning (shown in grid; hidden by CSS in list mode) -->
    @if (isLowStock()) {
    <span class="card__low-stock">
      Últimas {{ product().stock }} unidades
    </span>
    }

  </div>

  <!-- ── Price zone (list mode only) ──────────────────────────── -->
  @if (viewMode() === 'list') {
  <div class="card__price-zone">
    @if (!isOutOfStock()) {
    <div class="card__price-zone-block">
      @if (product().isOnSale && product().originalPrice != null) {
      <span class="card__original-price">{{ formattedOriginalPrice() }}</span>
      }
      <span class="card__price-zone-price" [class.card__price-zone-price--sale]="product().isOnSale">{{ formattedPrice() }}</span>
    </div>
    }

    @if (product().isPreSale) {
      <span class="card__stock-label card__stock-label--pre-sale">
        Pre-venta · {{ product().prepurchase_stock }} cupos
      </span>
    } @else if (isOutOfStock()) {
      <span class="card__stock-label">Agotado</span>
    } @else if (isLowStock()) {
      <span class="card__stock-label card__stock-label--warning">Últimas {{ product().stock }} unidades</span>
    } @else {
      <span class="card__stock-label">{{ product().stock }} unidades</span>
    }
  </div>
  }

  <!-- ── Actions zone (list mode only) ────────────────────────── -->
  @if (viewMode() === 'list') {
  <div class="card__actions-zone">
    <app-wishlist-button class="card__wishlist-btn card__wishlist-btn--list" [productId]="product().id" [iconSize]="14" />

    <button
      type="button"
      class="card__compare-btn card__compare-btn--list"
      [class.card__compare-btn--selected]="isInCompare()"
      [disabled]="!canAddToCompare()"
      [attr.aria-pressed]="isInCompare()"
      [attr.aria-label]="compareTooltip()"
      [attr.title]="compareTooltip()"
      (click)="onCompareToggle($event)"
    >
      @if (isInCompare()) {
        <app-icon [icon]="checkIcon" [size]="14" color="currentColor" />
        <span>En comparador</span>
      } @else {
        <app-icon [icon]="compareIcon" [size]="14" color="currentColor" />
        <span>Comparar</span>
      }
    </button>

    @if (product().isPreSale && !isOutOfStock()) {
      <!-- Precompras en list: CTA directa al modal, sin selector de qty ni carrito.
           El modal pide la cantidad para respetar prepurchase_limit vs prepurchase_stock. -->
      <app-button variant="primary" size="sm" (click)="onReserve($event)">
        <div class="card__add-btn-content">
          <app-icon [icon]="calendarIcon" [size]="14" />
          <span>Reservar</span>
        </div>
      </app-button>
    } @else if (isPrepurchaseSoldOut()) {
      <app-button
        variant="primary"
        size="sm"
        class="btn-sold-out"
        [appTooltip]="prepurchaseSoldOutMessage"
        (click)="onPrepurchaseSoldOutClick($event)"
      >
        <div class="card__add-btn-content">
          <app-icon [icon]="calendarIcon" [size]="14" />
          <span>Precompra Agotada</span>
        </div>
      </app-button>
    } @else if (!isOutOfStock()) {
      <div class="card__quantity">
        <button
          class="card__qty-btn"
          [disabled]="!canDecrement()"
          (click)="decrement($event)"
          aria-label="Reducir cantidad"
        >
          <app-icon [icon]="minusIcon" [size]="14" />
        </button>
        <span class="card__qty-value">{{ quantity() }}</span>
        <button
          class="card__qty-btn"
          [disabled]="!canIncrement()"
          (click)="increment($event)"
          aria-label="Aumentar cantidad"
        >
          <app-icon [icon]="plusIcon" [size]="14" />
        </button>
      </div>

      <app-button variant="primary" size="sm" (click)="onAddToCart($event)">
        <div class="card__add-btn-content">
          @if (justAdded()) {
            <app-icon [icon]="checkIcon" [size]="14" />
            <span>Añadido</span>
          } @else {
            <app-icon [icon]="cartIcon" [size]="14" />
            <span>Añadir</span>
          }
        </div>
      </app-button>
    } @else if (!product().isPreSale) {
      @if (isNotifyActive()) {
        <app-button class="card__notify-cancel" variant="ghost" size="sm" (click)="onNotify($event)">
          <div class="card__notify-cancel-btn card__add-btn-content">
            <app-icon [icon]="bellOffIcon" [size]="14" />
            <span>Ya no me avises</span>
          </div>
        </app-button>
      } @else {
        <app-button variant="secondary" size="sm" (click)="onNotify($event)">
          <div class="card__add-btn-content">
            <app-icon [icon]="bellIcon" [size]="14" />
            <span>Avisarme</span>
          </div>
        </app-button>
      }
    }
  </div>
  }
</article>
